import { create } from "zustand";

interface CustomAddressStore {
  keyword: string;
  selectedIdx: number | null;
  drawerOpen: boolean;
  setKeyword: (keyword: string) => void;
  openDrawerForAdd: () => void;
  openDrawerForEdit: (caIdx: number) => void;
  closeDrawer: () => void;
}

export const useCustomAddressStore = create<CustomAddressStore>((set) => ({
  keyword: "",
  selectedIdx: null,
  drawerOpen: false,
  setKeyword: (keyword) => set({ keyword }),
  openDrawerForAdd: () => set({ selectedIdx: null, drawerOpen: true }),
  openDrawerForEdit: (caIdx) => set({ selectedIdx: caIdx, drawerOpen: true }),
  closeDrawer: () => set({ drawerOpen: false, selectedIdx: null }),
}));
